<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">公示标题</p>
        <el-input v-model="searchFrom.title" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
      <el-button class="searchBtn" type="warning" @click="addFormData">发布动态</el-button>
    </div>
    <!--      列表-->
    <div class="table">
      <div class="searchList">
        <TableList :data="tableData" :columnDefs="tableColumns" :total="totalCount" @pageChange="handleCurrentChange">
          <template #action="{ row, index }" class="tableButton">
            <el-button class="tableBtn" @click="viewOrHandle(row, 'edit')" type="text" size="small">编辑
            </el-button>
            <el-button class="tableBtn" @click="viewOrHandle(row, 'view')" type="text" size="small">查看详情
              </el-button>
            <el-button class="tableBtn" @click="deleteFun(row)" type="text" size="small">删除</el-button>
          </template>
        </TableList>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { Message } from 'element-ui'
import TableList from '@/components/TableList'
import { partyNewsInfo } from '@/api/comprehensive'
export default {
  name: 'accountPage',
  components: {
    TableList,
  },
  data() {
    return {
      loading: false,
      searchFrom: {
        title: '',
      },
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      dialogFormVisible: false,
      eventControl: '',
      edit: false,
      passwordForm: {},
      addForm: {
        title: '', // 标题
      },
      rules: {
        title: [{ required: true, message: '请填写', trigger: 'blur' }],
        content: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      tableData: [],
      tableColumns: [
        {
          prop: 'title',
          label: '标题'
        },
        // {
        //   prop: 'status',
        //   label: '状态',
        //   formatter: (row, column, v) => {
        //     return row.status === 1 ? '已查看' : '未查看'
        //   }
        // },
        {
          prop: 'action',
          label: '操作',
        },
      ]
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    handleFile(imgs) {
      let arrFile = imgs.map(v => v.name).join(',')
      this.addForm.fileUrlList = arrFile
    },
    getData() {
      this.currentPage = 1
      this.queryList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.queryList()
    },
    async queryList() {
      let res = await partyNewsInfo('query', {
        title: this.searchFrom.title,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = res.result.records
        this.totalCount = res.result.total
      }
    },
    addFormData() {
      this.$router.push({
        path: '/partyBuilding/addParty',
        // path: '/contract/addTax',
        query: {
          isEdit: 'add'
        }
      })
    },
    async viewOrHandle(row, type) {
      console.log(row);
      this.$router.push({
        path: '/partyBuilding/addParty',
        // path: '/contract/addTax',
        query: {
          isEdit: type,
          id: row.id
        }
      })
    },
    // 删除用户
    deleteFun(row) {
      this.$confirm('此操作将删除公示, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': row.id
        }
        let res = await partyNewsInfo('deleteById', params)
        if (res.code === 0) {
          Message.success('删除成功！')
        }
        await this.getData()
      })
    }
  }
}
</script>
  
  <style lang="scss" scoped>
  .app-inner {
    width: 98%;
    height: 70vh;
    padding: 0.2rem;
    box-sizing: border-box;
  }
  
  .searchTitleDiv {
    width: 15rem;
    height: 0.66rem;
    margin-left: 0.2rem;
    margin-top: 0.05rem;
    /*display: flex;*/
    /*justify-content: space-around;*/
  
    .stateDiv {
      margin-top: 0.14rem;
      margin-left: .3rem;
      float: left;
    }
  
    .searchText {
      margin-top: 0.05rem;
      margin-right: 0.13rem;
      font-size: 0.2rem;
      color: #111111;
      float: left;
    }
  
    .inputDiv {
      width: 2.2rem;
      float: left;
    }
  
    .searchBtn {
      /*width: 1.20rem;*/
      /*height: 0.36rem;*/
      /*border-radius: 0.06rem;*/
      /*font-size: 0.18rem;*/
      margin-top: 0.14rem;
      margin-left: .3rem;
      /*padding-top: 0.1rem;*/
    }
  }
  
  .table {
    margin-top: .3rem;
    margin-left: .5rem;
    text-align: center;
    width: 14.8rem;
  
    .searchList {}
  
    .paginationBody {
      margin-top: .1rem;
    }
  }
  
  .formItem {
    // width: 3.2rem;
  }
  
  /deep/ .el-dialog {
    width: 30% !important;
  }
  </style>